<template>
  <div class="UsrBox">
    <i class="el-icon-user-solid" :style="{color:color}" />
    <el-link class="link" v-if="!VisLogin" @click="fnHandleLogin" :style="{color:color}">{{$t('util.ljdl')}}</el-link>
    <el-dropdown class="link" size="medium" style="margin-right: 15px;cursor: pointer" @command="handleCurrencyChange" v-else>
        <span class="el-dropdown-link" :style="{color:color}">
        {{VuserType === 'B2C' ? VuserInfo.trueName : (VcompanyInfo && VcompanyInfo.type ? ['[',VcompanyInfo.type,']',VuserInfo.trueName].join('') : VuserInfo.trueName)}}
        </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="userCenter">{{$t('util.wddd')}}</el-dropdown-item>
        <el-dropdown-item command="loginOut">{{$t('util.tcdl')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <login-box ref="LoginBox" @close="fnLoginBoxClose" />
  </div>
</template>

<script>
import LoginBox from './loginBox'
export default {
  name: 'UsrBox',
  components: {LoginBox},
  data () {
    return {
      loginTips: null
    }
  },
  props: {
    color: {
      type: String,
      default: '#455873'
    }
  },
  watch: {
    VisLogin: {
      handler (v1) {
        if (!v1) {
          const h = this.$createElement
          const that = this
          this.loginTips = this.$notify({
            dangerouslyUseHTMLString: true,
            duration: 0,
            message: h('div', {
              style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '260px',
                marginBottom: '8px'
              }
            }, [
              h('el-image', {
                style: {
                  width: '64px',
                  marginBottom: '8px'
                },
                props: {
                  src: require('../../assets/gifits.png')
                }
              }),
              h('strong', {
                style: {
                  marginBottom: '8px'
                }
              }, this.$t('util.drhqhyzg')),
              h('el-button', {
                style: {
                  width: '100%'
                },
                props: {
                  size: 'medium',
                  plain: true,
                  type: 'primary'
                },
                on: {
                  click: () => {
                    that.fnHandleLogin()
                    this.loginTips.close()
                  }
                }
              }, this.$t('util.drhzc'))
            ])
          })
        }
      },
      immediate: true
    }
  },
  destroyed () {
    if (this.loginTips) {
      this.loginTips.close()
    }
  },
  methods: {
    handleCurrencyChange (cmd) {
      if (cmd === 'userCenter') {
        this.toUserCenter()
      } else {
        this.loginOut()
      }
    },
    fnLoginBoxClose (t) {
      window.location.reload(-1)
    },
    fnHandleLogin () {
      this.$refs.LoginBox.openWin()
    }
  }
}
</script>

<style scoped lang="scss">
.UsrBox{
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  & .el-icon-user-solid{
    margin-right: 5px;
  }
  & .link{
    font-size: 12px;
    text-align: left;
    white-space: nowrap;
    max-width: 100px;
    overflow: hidden;
    text-overflow:ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/usrBox.vue